import { PodcastMetricsByDay } from 'api';
import { displayDate } from 'utils/date';

export const mapPodcastMetricsByDay = (metrics?: PodcastMetricsByDay[]) => {
  if (!metrics) return [];

  return metrics.map((stat) => ({
    dateMillis: stat.dayMillis,
    date: displayDate(stat.dayMillis),
    plays: stat.playCount,
  }));
};
